import { Injectable } from '@angular/core';
import { HttpService } from '../../services/HttpService';
import { INavigation } from '../../models/INavigation';
import { zip } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { menu } from '../../routes/menu';
import * as _ from 'lodash';


@Injectable()
export class MenuService {
    menuItems: Array<INavigation> = [];

    constructor(private http: HttpService) {
    }

    contains(userRoles, menuRoles) {
        const intersection = _.intersection(userRoles, menuRoles);
        return intersection.length !== 0;
    }

    getMenu(userRoles: string[]): INavigation[] {
        this.menuItems = [];

        _.each(menu, (item) => {
            if (item.roles == null || this.contains(userRoles, item.roles)) {
                this.menuItems.push(item);
            }
        });

        return this.menuItems;
    }
}
